import { render, staticRenderFns } from "./SoftwareDistribute.vue?vue&type=template&id=704cb647&scoped=true&"
import script from "./SoftwareDistribute.vue?vue&type=script&lang=js&"
export * from "./SoftwareDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704cb647",
  null
  
)

export default component.exports